module.exports = __webpack_public_path__ + "media/react/features/dashboard/assets/connections-empty-state-e1c2a60260a5f6b705842f56f0b71dc9.png";